import 'transitionEnd';
import {render} from 'react-dom';
import Arg from '@livongo/arg';
import {getStoredLang} from '@teladoc/pulse/ui/App/g11n';
import {useI18nContext} from '@teladoc/pulse/ui/Context/i18n';
import APIUtils from '@livongo/utils/api';
import MixpanelUtils from '@livongo/utils/mixpanel';
import NewRelicUtils from '@livongo/utilities/system/newrelic';
import PulseApp, {STATUSES} from '@teladoc/pulse/ui/App';
import App from './App';
import 'sass/main.scss';

const IS_DEV =
    (window?.process?.env?.TGPS_ENV ?? process.env.NODE_ENV) === 'development';

MixpanelUtils.init(
    window?.process?.env?.MIXPANEL_TOKEN ?? process.env.MIXPANEL_TOKEN
);

APIUtils.init({
    baseUrl: window?.process?.env?.API_URL ?? process.env.API_URL,
    additionalHeaders: {
        'Accept-Language': getStoredLang(),
    },
});

// Update New Relic key values for this repository
const nrObject = {
    ACCOUNT_ID: window?.process?.env?.ACCOUNT_ID ?? process.env.ACCOUNT_ID,
    TRUST_KEY: window?.process?.env?.TRUST_KEY ?? process.env.TRUST_KEY,
    AGENT_ID: window?.process?.env?.AGENT_ID ?? process.env.AGENT_ID,
    LICENSE_KEY: window?.process?.env?.LICENSE_KEY ?? process.env.LICENSE_KEY,
    APPLICATION_ID:
        window?.process?.env?.APPLICATION_ID ?? process.env.APPLICATION_ID,
};

// Initialize New Relic
NewRelicUtils.init({document, nrObject});

const Wrapper = () => {
    const {selectedLang, scopedLangCodes, changeLanguage} = useI18nContext();
    const locale = Arg('locale');

    if (locale && scopedLangCodes.includes(locale)) {
        changeLanguage(locale);
    }

    return <App selectedLang={selectedLang} />;
};

render(
    <PulseApp
        i18n={{
            debug: IS_DEV,
            defaultNS: 'remonj',
            ns: ['remonj'],
            resources: {
                'en-US': {
                    remonj: require('i18n/locales/en-US.json'),
                },
                'es-US': {
                    remonj: require('i18n/locales/es-US.json'),
                },
            },
        }}
        render={({status}) => {
            switch (status) {
                case STATUSES.INITIALIZED:
                    return <Wrapper />;
            }
        }}
    />,
    document.getElementById('root')
);
